import styled from 'styled-components';
import { rem } from 'polished';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem('20px')};
`;

export const Modal = styled.div`
  background: #ffffff;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${rem('16px')};
  right: ${rem('16px')};
  background: none;
  border: none;
  font-size: ${rem('24px')};
  color: #6b7280;
  cursor: pointer;
  width: ${rem('32px')};
  height: ${rem('32px')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #1f2937;
  }
`;

export const FormContainer = styled.div`
  padding: ${rem('32px')};
`;

export const Title = styled.h2`
  font-family: 'MontserratBlack', sans-serif;
  font-size: ${rem('26px')};
  color: #1f2937;
  margin: 0 0 ${rem('8px')} 0;
  font-weight: 800;
  letter-spacing: -0.5px;
`;

export const Subtitle = styled.p`
  font-size: ${rem('14px')};
  color: #6b7280;
  margin: 0 0 ${rem('24px')} 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${rem('16px')};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('6px')};
`;

export const Label = styled.label`
  font-size: ${rem('14px')};
  font-weight: 600;
  color: #374151;
`;

export const Input = styled.input`
  padding: ${rem('12px')} ${rem('16px')};
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: ${rem('16px')};
  transition: all 0.2s ease;
  background: #ffffff;

  &:focus {
    outline: none;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const TextArea = styled.textarea`
  padding: ${rem('12px')} ${rem('16px')};
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: ${rem('16px')};
  min-height: 120px;
  resize: vertical;
  font-family: inherit;
  transition: all 0.2s ease;
  background: #ffffff;

  &:focus {
    outline: none;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const SubmitButton = styled.button`
  padding: ${rem('14px')} ${rem('24px')};
  background: #1a1a1a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: ${rem('16px')};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: ${rem('8px')};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SuccessMessage = styled.div`
  text-align: center;
  padding: ${rem('40px')} ${rem('32px')};

  h3 {
    font-size: ${rem('24px')};
    color: #10b981;
    font-weight: 700;
    margin: 0 0 ${rem('12px')} 0;
  }

  p {
    font-size: ${rem('16px')};
    color: #6b7280;
    margin: 0;
  }
`;

export const ErrorMessage = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: ${rem('12px')};
  border-radius: 8px;
  font-size: ${rem('14px')};
`;
